import { render } from "./isBugButton.vue?vue&type=template&id=2a82c7df&scoped=true"
import script from "./isBugButton.vue?vue&type=script&lang=js"
export * from "./isBugButton.vue?vue&type=script&lang=js"

import "./isBugButton.vue?vue&type=style&index=0&id=2a82c7df&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a82c7df"]])

export default __exports__